module.exports = __webpack_public_path__ + "static/media/pool-hall9.97865e2f.jpg";